import type { PayloadAction } from '@reduxjs/toolkit';
import { EditPaymentMethodActionPayload } from '@/domains/payments/features/paymentModals/modals/EditPaymentMethod/types/EditPaymentMethodActionPayload';
import { call, takeLatest } from 'redux-saga/effects';
import { Modals } from '@/features/serviceModal/enums/Modals';
import { SnackType } from '@/features/snacks/enums/SnackType';
import { editPaymentMethod } from '@/domains/payments/features/paymentModals/modals/EditPaymentMethod/store/editPaymentMethod.slice';
import PaymentFormEvent from '@/domains/payments/features/paymentModals/shared/events';
import EventService from '@/services/EventService/EventService';
import HttpService from '@/services/HttpService/HttpService';
import ModalService from '@/services/ModalService/ModalService';
import SnacksService from '@/services/SnackService/SnackService';

function* editPaymentMethodSaga({
  payload: { paymentMethodId, ...body },
}: PayloadAction<EditPaymentMethodActionPayload>) {
  try {
    yield call(HttpService.patch, `/Payment/update-payment-method/${paymentMethodId}`, body, {
      baseURL: import.meta.env.VITE_API_URL,
    });

    SnacksService.add({
      type: SnackType.Success,
      title: 'Payment Information has been updated successfully',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    });
    ModalService.close(Modals.EditPaymentMethod);
    EventService.dispatch(new PaymentFormEvent.PaymentMethodSuccess({}));
  } catch (error) {
    console.error(error);
    ModalService.close(Modals.EditPaymentMethod);
  } finally {
    EventService.dispatch(new PaymentFormEvent.CreateRequestSuccess({}));
  }
}

export function* editPaymentMethodWatcher() {
  yield takeLatest([editPaymentMethod.type], editPaymentMethodSaga);
}
